var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeekArrowTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220px",
    height: "219px",
    viewBox: "0 0 220 219",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pixagri",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aide-12",
    transform: "translate(-620.000000, -144.000000)",
    stroke: "#9EBE4A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow55",
    transform: "translate(730.109967, 253.635675) rotate(-47.000000) translate(-730.109967, -253.635675) translate(655.256422, 177.727511)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line-21",
    strokeLinejoin: "round",
    transform: "translate(3.387720, 95.179837) rotate(-183.000000) translate(-3.387720, -95.179837) ",
    points: "0.166355801 91.9168689 6.397721 91.9636915 6.60908432 98.4428056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3856977,18.2083018 C30.409642,35.4700629 48.5470569,99.0082257 68.8089283,116.914647 C82.3168426,128.852262 101.524665,134.387338 126.432394,133.519878",
    id: "Line-8",
    transform: "translate(75.909046, 75.908163) scale(1, -1) rotate(-33.000000) translate(-75.909046, -75.908163) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekArrowTop);
export default __webpack_public_path__ + "static/media/week_arrow_top.216abf67.svg";
export { ForwardRef as ReactComponent };